<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="main" slot-scope="{ item }">
            {{ item.main | yesno }}
        </template>
        <template slot="actions" slot-scope="{ item }">
            <b-button size="sm" variant="primary" @click="seeDetails(item)"
                ><i class="fa fa-search-plus"></i
            ></b-button>
            <b-button size="sm" variant="primary" @click="updateContact(item)"
                ><i class="fa fa-pencil"></i
            ></b-button>
            <b-button size="sm" variant="danger" @click="removeContact(item)"
                ><i class="fa fa-trash"></i
            ></b-button>
        </template>
    </app-data-table>
</template>
<script>
import fields from './fields'
export default {
    props: {
        data: {
            type: Object,
        },
    },
    data() {
        return {
            fields,
        }
    },
    methods: {
        onChangePage(page) {
            this.$emit('change-page', page)
        },
        updateContact(data) {
            this.$emit('update-contact', data)
        },
        removeContact(data) {
            this.$emit('remove-contact', data)
        },
        seeDetails(data) {
            this.$emit('see-details-contact', data)
        },
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
}
</script>
